const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
const iosPlatforms = ['iPhone', 'iPad', 'iPod']

export type OS = 'mac' | 'windows' | 'android' | 'ios' | 'linux'

declare global {
  interface Navigator {
    userAgentData?: {
      platform?: string
    }
  }
}

function getOS(): OS | undefined {
  const userAgent = window.navigator.userAgent
  const platform =
    window.navigator?.userAgentData?.platform || window.navigator.platform

  if (macosPlatforms.indexOf(platform) !== -1) {
    return 'mac'
  }

  if (iosPlatforms.indexOf(platform) !== -1) {
    return 'ios'
  }

  if (windowsPlatforms.indexOf(platform) !== -1) {
    return 'windows'
  }

  if (/Android/.test(userAgent)) {
    return 'android'
  }

  if (/Linux/.test(platform)) {
    return 'linux'
  }

  return undefined
}

export const os = getOS()
if (os) {
  document.documentElement.classList.add(os)
}
